import { HttpHelper } from "../../common/helper/http-helper-service";
import { constants } from "../../common/constant/constants";

export default class ServiceProviderServices {
  static getEmailConfigurationListByServiceProvider = (_params: any = null) => {
    return HttpHelper.getData(
      constants.apiUrl.serviceProviderUrls
        .getEmailConfigurationListByServiceProvider + "?api-version=1.0",
      {},
    );
  };

  static getCustomDomainConfiguration = () => {
    return HttpHelper.getData(
      constants.apiUrl.serviceProviderUrls.getCustomDomainConfiguration +
        "?api-version=1.0",
      {},
    );
  };

  static doesEmailConfigurationExist = () => {
    let url = constants.apiUrl.serviceProviderUrls.doesemailconfigurationexist;
    return HttpHelper.getData(url, []);
  };

  static getInvoiceTemplateList() {
    return HttpHelper.getData(
      constants.apiUrl.serviceProviderUrls.getInvoiceTemplateList +
        "?api-version=1.0",
      {},
    );
  }

  static async getTicketReopenThreshold(_param: any) {
    return HttpHelper.getData(
      constants.apiUrl.serviceProviderUrls.getTicketReopenThreshold +
        "?api-version=1.0",
      {},
    );
  }

  static getTicketTypeSettings = () => {
    return HttpHelper.getData(
      constants.apiUrl.serviceProviderUrls.getTicketTypeSettings,
      {},
    );
  };

  static getServiceProviderWorkingDays = () => {
    return HttpHelper.getData(
      constants.apiUrl.serviceProviderUrls.getServiceProviderWorkingDays,
      {},
    );
  };

  static getServiceProviderLocationById = (id: number) => {
    return HttpHelper.getData(
      constants.apiUrl.serviceProviderUrls.getServiceProviderLocation +
        "/" +
        id +
        "?api-version=1.0",
      {},
    );
  };
}
